module.exports = __webpack_public_path__ + "img/電気回路_3_7_1.3c1652f0.png";